import { io, Socket } from 'socket.io-client';

const ServerError = {
	ROOM_CREATE_ERROR: '방 생성 중 오류가 발생하였습니다.',
	ROOM_CREATE_TIME: '경매 대시 시간과 진행 시간은 각각 3, 5, 8, 10초 중에서 설정 할 수 있습니다.',
	ROOM_CREATE_ID_NOT_SET: '방 ID를 입력하여 주십시오.',
	ROOM_CREATE_ID_NOT_VALID: '방 ID를 올바르게 입력하여 주십시오.',
	ROOM_CREATE_EXISTS: '이미 존재하는 방 ID입니다.',
	ROOM_CREATE_ALREADY_JOIN: '현재 방에 참여 중인 상태입니다.',
	ROOM_JOIN_ERROR: '방 참가 중 오류가 발생하였습니다.',
	ROOM_JOIN_ID_NOT_SET: '방 ID를 입려하여 주십시오.',
	ROOM_JOIN_ID_NOT_VALID: '방 ID를 올바르게 입력하여 주십시오.',
	ROOM_JOIN_NOT_EXISTS: '존재하지 않는 방 ID입니다. [1]',
	ROOM_JOIN_FULL: '경매가 진행 중인 방입니다.',
	ROOM_JOIN_PASSWORD_WRONG: '방 입장을 위한 암호가 올바르지 않습니다.',
	ROOM_JOIN_ALREADY_JOIN: '현재 방에 참여 중인 상태입니다.',
	ROOM_READY_NOT_EXIST: '존재하지 않는 방 ID입니다. [2]',
	GAME_BIDDING_WAIT_FOR_NEXT: '다음 경매 준비 중입니다.\n경매 시작 후 입찰하여 주십시오.',
	GAME_BIDDING_ALREADY_BIDDING: '최대 입찰로 참여 중입니다.',
	GAME_BIDDING_LANE_HAVE: '해당 래인(포지션)에 낙찰받은 선수가 있습니다.',
	GAME_BIDDING_PLAYER_HAS_DIRECTOR: '해당 선수는 이미 낙찰되었습니다.',
	GAME_BIDDING_NOT_ENOUGH_POINT: '포인트가 부족합니다.',
	GAME_BIDDING_POINT_ERROR: '포인트는 5단위로 최대 1000포인트까지 사용가능합니다.',
	GAME_BIDDING_REQUIRE_MORE: '상위 입찰자가 있습니다.',
	GAME_BIDDING_NOT_BID_DIRECTOR: '낙찰 받을 수 없습니다.',
	GAME_BIDDING_TIMEOUT: '입찰 시간이 초과되었습니다.',
};

export const ServerEvent = {
	ERROR: 'error',
	CREATE: 'create',
	QUICK: 'quick',
	JOIN: 'join',
	JOIN_START_GAME: 'join_start_game',
	JOIN_SOMEONE: 'join_someone',
	JOIN_SOMEONE_START_GAME: 'join_someone_start_game',
	LEAVE: 'leave',
	LEAVE_SOMEONE: 'leave_someone',
	READY_CHECK: 'ready_check',
	READY_OK: 'ready_ok',
	START: 'start',
	START_AUCTION: 'start_auction',
	END_AUCTION: 'end_auction',
	NEXT_AUCTION: 'next_auction',
	BIDDING: 'bidding',
	BID_FAILURE: 'bid_failure',
	BID: 'bid',
	BID_FORCE: 'bid_force',
	RESPONSE: 'response',
	END: 'end',
}

export default class Server {
	/**
	 * 소켓 인스턴스
	 * @type {Server}
	 */
	static instance;
	
	/**
	 * 개발모드?
	 * @type {boolean}
	 */
	static isDevMode = false;
	
	/**
	 * @type {Socket}
	 */
	socket;
	
	/**
	 * @type {(0|1|2|3|4|5)}
	 */
	position;
	
	callBack = {}
	
	static modal;
	
	/**
	 * 상태 변경 함수
	 * @type {function}
	 */
	static statusChange;
	
	/**
	 * @param {string} host
	 * @param room
	 */
	constructor(host) {
		this.socket = io(host, {path: '/game/', transports: ['websocket'], rejectUnauthorized: false});
		this.socket.io.on('error', (err) => {
			console.log(err);
			Server.statusChange('error');
			Server.alert('서버에 연결할 수 없습니다.<br><br>잠시 후 다시 시도하여 주십시오.');
		});
		
		this.socket.on('error', (type, msg) => {
			Server.alert(ServerError[type.toUpperCase()] || msg);
		});
		
		this.socket.on(ServerEvent.JOIN,
			/**
			 * @param {{position: (0|1|2|3|4|5), players: (1|2|3|4|5|6)}} data
			 */
			(data) => {
				this.position = Number(data.position);
				if (this.isDevMode) {
					console.log(`Event [${ServerEvent.JOIN}] : Position => ${data.position}, Players => ${data.players}`);
				}
			}
		);
		
		this.socket.on(ServerEvent.READY_CHECK, () => {
			this.socket.emit(ServerEvent.READY_OK);
		});
		
		this.socket.onAny((event, ...args) => {
			if (this.callBack[event]) {
				for (const cb of this.callBack[event]) {
					cb(...args);
				}
			}
		});
	}
	
	/**
	 * 개발환경 모드인가?
	 * @returns {boolean}
	 */
	get isDevMode() {
		return Server.isDevMode;
	}
	
	/**
	 * 연결
	 * @param {string}host
	 * @returns {Server}
	 */
	static connect(host) {
		if (!Server.instance) {
			Server.instance = new Server(host);
		}
		return Server.instance;
	}
	
	/**
	 * 알림 모달 연결
	 * @param modal
	 */
	static setModal(modal) {
		Server.modal = modal;
	}
	
	/**
	 * 상태 변경 함수 연결
	 * @param {function} func
	 */
	static setStatusChange(func) {
		Server.statusChange = func;
	}
	
	static alert(msg) {
		if (typeof Server.modal === 'function') {
			Server.modal(msg);
		} else {
			alert(msg);
		}
	}
	
	/**
	 * 개발환경 모드
	 * @param {boolean} on
	 */
	static devMode(on) {
		Server.isDevMode = !!on;
	}
	
	/**
	 * 연결해제
	 */
	disconnect() {
		this.socket.disconnect();
		Server.instance = null;
	}
	
	/**
	 * 이벤트 콜백 추가
	 * @param {string} eventType
	 * @param {function} callback
	 */
	addCallback(eventType, callback) {
		if (!this.callBack[eventType]) {
			this.callBack[eventType] = [];
		}
		this.callBack[eventType].push(callback);
	}
	
	/**
	 * 빠른 참가
	 * @returns {Server}
	 */
	quick() {
		this.socket.emit(ServerEvent.QUICK);
		return this;
	}
	
	/**
	 * 방생성
	 * @param {string} id
	 * @param {string} pw
	 * @param {number} waitTime
	 * @param {number} auctionTime
	 * @returns {Server}
	 */
	create(id, pw, waitTime, auctionTime) {
		this.socket.emit(ServerEvent.CREATE, id,  pw, waitTime, auctionTime);
		return this;
	}
	
	/**
	 * 방참가
	 * @param {string} id
	 * @param {string} pw
	 */
	join(id, pw) {
		this.socket.emit(ServerEvent.JOIN, id, pw);
		return this;
	}
	
	/**
	 * 경매 시작 / 시간 갱신
	 */
	start_auction() {
		this.socket.emit(ServerEvent.START_AUCTION);
		return this;
	}
	
	end_auction() {
		this.socket.emit(ServerEvent.END_AUCTION);
		return this;
	}
	
	next() {
		this.socket.emit(ServerEvent.NEXT_AUCTION);
		return this;
	}
	
	/**
	 * 입찰
	 * @param {number} point
	 */
	bidding(point) {
		this.socket.emit(ServerEvent.BIDDING, point);
		return this;
	}
	
	/**
	 * 응답
	 * @param {string} type
	 * @returns {Server}
	 */
	response(type) {
		this.socket.emit(ServerEvent.RESPONSE, type);
		return this;
	}
}